export default __webpack_public_path__ + "static/media/pic3.12bc4890.jpg";